module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brutto text-dark"
  }, [_c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "showClose": false
    }
  }, [_c('div', {
    staticClass: "brutto-container",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "brutto-container__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.task_versions.save_task_overview_version')))]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle doc-modal__close",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-container__body"
  }, [(_vm.theTab === 1) ? _c('div', {
    staticClass: "brutto__users"
  }, [_c('div', {
    staticClass: "d-input-group"
  }, [_c('h4', {
    staticClass: "marg-05-bottom"
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.version_title')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newVersionTitle),
      expression: "newVersionTitle"
    }],
    ref: "version_name_input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newVersionTitle)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.theTab = 2
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newVersionTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-desc"
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.auto_name_description')))])]), _vm._v(" "), _c('div', {
    staticClass: "save-versions__explained"
  }, [_c('ul', {
    staticClass: "d-event__actions text-dark"
  }, [_c('li', {
    staticClass: "d-event__actions__action",
    class: {
      'd-event__actions__action--open': _vm.getTheFAQAcc(0)
    }
  }, [_c('h4', {
    on: {
      "click": function($event) {
        return _vm.setTheFAQAcc(0)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.task_versions.what_is_version')) + "\n                  "), _c('svg', {
    staticClass: "tw-icon w-6 h-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M19.5 8.25l-7.5 7.5-7.5-7.5"
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "accordion"
    },
    on: {
      "enter": _vm.start,
      "after-enter": _vm.end,
      "before-leave": _vm.start,
      "after-leave": _vm.end
    }
  }, [(_vm.getTheFAQAcc(0)) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.task_versions.saved_task_overview_description')))])]) : _vm._e()])], 1), _vm._v(" "), _c('li', {
    staticClass: "d-event__actions__action",
    class: {
      'd-event__actions__action--open': _vm.getTheFAQAcc(1)
    }
  }, [_c('h4', {
    on: {
      "click": function($event) {
        return _vm.setTheFAQAcc(1)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.task_versions.find_saved_versions')) + "\n                  "), _c('svg', {
    staticClass: "tw-icon w-6 h-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M19.5 8.25l-7.5 7.5-7.5-7.5"
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "accordion"
    },
    on: {
      "enter": _vm.start,
      "after-enter": _vm.end,
      "before-leave": _vm.start,
      "after-leave": _vm.end
    }
  }, [(_vm.getTheFAQAcc(1)) ? _c('div', [_c('p', [_vm._v("\n                      " + _vm._s(_vm.$t('vue2.task_versions.find_saved_versions_description')) + "\n                    ")])]) : _vm._e()])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.theTab === 2) ? _c('div', {
    staticClass: "brutto__users"
  }, [(_vm.tags.length > 0) ? _c('div', {
    staticClass: "brutto__users__header"
  }, [_c('filterTags', {
    attrs: {
      "users": _vm.usersSortedOnNameWithTags,
      "tags": _vm.tags,
      "selectedTags": _vm.appliedFilters
    },
    on: {
      "set": _vm.setTagFromFilter,
      "remove": _vm.removeTagFromFilter
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "brutto__users__list__header",
    on: {
      "click": _vm.toggleAll
    }
  }, [(_vm.selectedUsers.length < 1) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.$t('vue2.tagging.select_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))])]), _vm._v(" "), _c('ul', {
    staticClass: "brutto__users__list"
  }, _vm._l((_vm.filteredUsers), function(user) {
    return _c('li', {
      key: user.id,
      staticClass: "brutto__users__user",
      class: {
        'is-selected': _vm.getIsUserSelected(user)
      },
      on: {
        "click": function($event) {
          return _vm.toggleUser(user)
        }
      }
    }, [_vm._v("\n              " + _vm._s(user.name) + "\n            ")])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "brutto-container__footer"
  }, [(_vm.theTab === 2) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.theTab = 1
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.go_back')))]) : _vm._e(), _vm._v(" "), (_vm.theTab === 1) ? _c('button', {
    staticClass: "bttn bttn-primary",
    on: {
      "click": function($event) {
        _vm.theTab = 2
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.task_versions.select_personnel')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.theTab === 2) ? _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        onShow: function () { return _vm.selectedUsers.length < 1; }
      }),
      expression: "{\n                  arrow: true,\n                  onShow: () => selectedUsers.length < 1\n                }"
    }],
    staticClass: "bttn bttn-primary",
    class: [{
      'bttn-primary--disabled': _vm.selectedUsers.length < 1
    }, {
      'bttn--loading': _vm.isSaving
    }],
    attrs: {
      "content": _vm.$t('vue2.task_versions.select_min_user')
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.save_for_selected_users')) + " " + _vm._s(_vm.selectedUsers.length) + " " + _vm._s(_vm.$t('vue2.task_versions.save_for_selected_users_of')) + " " + _vm._s(_vm.filteredUsers.length) + "\n        ")]) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d3ef7c36!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TaskOverview/SaveTaskOverview.vue
// module id = 2130
// module chunks = 1